<template>
  <v-form ref="form" v-model="valid" lazy-validation class="catalogo-form">
    <v-row align="center" class="catalogo-row">
      <v-card class="catalogo-card"><v-card-title>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Pesquisar"
            single-line
            hide-details
          ></v-text-field>
        </v-card-title>
        <v-data-table
          v-if="tableOptions.itemsPerPage !== -1"
          :headers="headers"
          :items="filteredList"
          :loading="loading"
          loading-text="Buscando dados..."
          class="elevation-1"
          :options.sync="tableOptions"
          :footer-props="{
            showFirstLastPage: true,
            itemsPerPageText: 'Items por página',
            itemsPerPageOptions: [5, 10, 15, 50, 100, -1],
          }"
        >
          <template v-slot:item.actions="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  color="info"
                  fab
                  small
                  type="button"
                  v-bind="attrs"
                  v-on="on"
                  @click="addServico(item)"
                  class="white--text"
                >
                  <v-icon> mdi-plus </v-icon>
                </v-btn>
              </template>
              <span>Adicionar servico</span>
            </v-tooltip>
          </template>
        </v-data-table>
        <catalogo-virtual-table
          v-else
          :headers="headers"
          :items="filteredList"
          :loading="loading"
          :items-per-page.sync="tableOptions.itemsPerPage"
          item-key="id"
        >
          <template v-slot:item.descricao="{ item }">
            <span class="catalogo-descricao" :title="item.descricao">
              {{ item.descricao }}
            </span>
          </template>
          <template v-slot:item.codigo="{ item }">
            {{ item.codigo === null || item.codigo === "" ? "NA" : item.codigo }}
          </template>
          <template v-slot:item.actions="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  color="info"
                  fab
                  small
                  type="button"
                  v-bind="attrs"
                  v-on="on"
                  @click="addServico(item)"
                  class="white--text"
                >
                  <v-icon> mdi-plus </v-icon>
                </v-btn>
              </template>
              <span>Adicionar servico</span>
            </v-tooltip>
          </template>
        </catalogo-virtual-table>
      </v-card>
    </v-row>
  </v-form>
</template>

<script>
import { mapState } from "vuex";
import CatalogoVirtualTable from "../../Shared/CatalogoVirtualTable.vue";
import { reindexarItensPlanoManutencao } from "../../../utils/planoManutencaoItens";

export default {
  name: "servico",
  components: {
    CatalogoVirtualTable,
  },
  data: () => ({
    search: "",
    valid: true,
    errorMessage: false,
    tableOptions: {
      itemsPerPage: 10,
    },
    headers: [
      { text: "Id", value: "id", sortable: true },
      { text: "Item", value: "descricao", sortable: true },
      { text: "", value: "actions", sortable: false },
    ],
  }),
  props: {
    servicosL: Array,
    showModal: Boolean,
  },
  computed: {
    ...mapState("servicoPlano", ["servicosPlano"]),
    filteredList() {
      return this.servicosPlano.filter((sp) => {
        return (
          (sp.id.toString().toLowerCase().includes(this.search.toLowerCase()) ||
            sp.descricao.toLowerCase().includes(this.search.toLowerCase())) &&
          sp.ativo === true
        );
      });
    },
    loading() {
      return !(this.servicosPlano != null && this.servicosPlano.length > 0);
    },
  },
  methods: {
    updateObjectEstate() {
      return this.$refs.form.validate();
    },

    clear() {
      this.$refs.form.reset();
      this.$refs.form.resetValidation();
    },

    addServico: function (sp) {
      try {
        if (!sp || !sp.id) {
          throw new Error("Serviço inválido.");
        }

        var servico = new Object();
        servico.idServicoPlano = sp.id;
        servico.descricao = sp.descricao;
        servico.idProduto = 0;
        servico.idCompartimento = 0;
        servico.produto = null;
        servico.compartimento = null;
        servico.periodos = null;
        servico.periodoL = null;
        servico.editingProduto = false;
        servico.editingCompartimento = false;

        this.servicosL.push(JSON.parse(JSON.stringify(servico)));
        const itens = reindexarItensPlanoManutencao(this.servicosL);
        this.servicosL.splice(0, this.servicosL.length, ...itens);
        this.$store.dispatch("ui/showSnackbar", {
          text: "Serviço adicionado ao plano.",
          color: "success",
          timeout: 2500,
        });
      } catch (erro) {
        this.$store.dispatch("ui/showSnackbar", {
          text: erro?.message || "Não foi possível adicionar o serviço ao plano.",
          color: "error",
          timeout: 3000,
        });
      }
    },
  },
};
</script>
<style scoped>
.catalogo-form,
.catalogo-row,
.catalogo-card {
  box-sizing: border-box;
  max-width: 100%;
  min-width: 0;
  width: 100%;
}

.catalogo-card {
  align-self: stretch;
  flex: 1 1 auto;
}

.catalogo-descricao {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  line-height: 1.35;
  overflow: hidden;
  overflow-wrap: anywhere;
  white-space: normal;
  word-break: normal;
}
</style>
